import Head from 'next/head';
import { useRouter } from 'next/router';
import Layout from 'components/layout';
import Header from 'components/support/header';
import MobileButton from 'components/button';
import style from 'styles/support/faq.module.scss';
import Search from 'components/search';
// import useSWR, { SWRConfig } from 'swr';
import React, { useRef, useState } from 'react';
import { GetServerSideProps } from 'next';
import Loading from 'components/loading';
import SideTabs from 'components/sideTabs';
import { Pagination, List } from 'antd';
import { pageSize } from 'constants/index';
import { action, actionServer } from 'action/index';
import cn from 'classnames';
interface IProduct {
  id: string;
  productName: string;
}

interface IFaq {
  id: string;
  title: string;
  updateTime: string;
}

interface IProps {
  productList: IProduct[];
  list: IFaq[];
  current: number;
  total: number;
  hotWords: string[];
  categoryId: string;
}

export default function Home(props: IProps) {
  const { productList, list, current, total, hotWords, categoryId } = props;

  const router = useRouter();

  if (router.isFallback) {
    return <Loading />;
  }

  const onStartSearch = (val: string) => {
    if (val) {
      router.push(`/support/faq/search?query=${val}`);
    }
  };
  return (
    <Layout key={categoryId}>
      <Head>
        <title>常见问题 - 小鱼易连-官网-让世界零距离</title>
      </Head>
      <section className={style.container}>
        <Header pageKey="faq" />
        <Search className={style.searchWrapper} hotWords={hotWords} onStartSearch={onStartSearch} />
        <div className={style.body}>
          <SideTabs classNames={style.sideTabs} productList={productList} activeId={categoryId} onClickTab={activeId => router.replace(`/support/faq/${activeId}`, undefined, { scroll: false })} />
          <div className={style.rightMain}>
            <MobileList categoryId={categoryId} list={list} total={total} current={current} />
            <PcList categoryId={categoryId} list={list} total={total} current={current} />
          </div>
        </div>
      </section>
    </Layout>
  );
}

interface IFaqListProps {
  categoryId: string;
  list: IFaq[];
  current: number;
  total: number;
}

const Item = (item: IFaq) => {
  const router = useRouter();
  const onViewInfo = () => {
    router.push(`/support/faq/detail/${item.id}`);
  };
  return (
    <div className={style.faqItem} key={item.id} onClick={onViewInfo}>
      <div className={style.title}>{item.title}</div>
      <div className={style.icon} />
    </div>
  );
};

const PcList = (props: IFaqListProps) => {
  const { categoryId, list, current, total: faqTotal } = props;
  const [faqList, setFaqList] = useState(list);
  const [total, setTotal] = useState(faqTotal);

  const onChangePage = async (page: number) => {
    const res = await action.getFaqList(categoryId, page, pageSize);
    if (res) {
      const { total, records } = res;
      setFaqList(records);
      setTotal(total);
    }
  };
  return (
    <div className={cn(style.pcWrapper, style['for-pc'])}>
      <div className={style.faqList}>
        {faqList.map(item => {
          return <Item {...item} key={item.id} />;
        })}
      </div>
      {total > pageSize && <Pagination showLessItems={true} className={style.pagination} total={total} defaultCurrent={current} showSizeChanger={false} pageSize={pageSize} onChange={onChangePage} />}
    </div>
  );
};

const MobileList = (props: IFaqListProps) => {
  const { categoryId, list, current, total: faqTotal } = props;
  const [faqList, setFaqList] = useState(list);
  const [total, setTotal] = useState(faqTotal);
  // 移动端
  const [loading, setLoading] = useState(false);
  const page = useRef(current);

  const onLoadMore = async () => {
    setLoading(true);
    page.current += 1;
    const res = await action.getFaqList(categoryId, page.current, pageSize);
    if (res) {
      const { total, records } = res;
      setTotal(total);
      setFaqList((list: any) => [...list, ...records]);
    }
    setLoading(false);
  };
  return (
    <List
      className={cn(style.faqList, style['for-mobile'])}
      // loading={initLoading}
      itemLayout="horizontal"
      loadMore={
        total > faqList.length && (
          <MobileButton category="viewMore" className={style.loadMore} onClick={onLoadMore} loading={loading}>
            查看更多
          </MobileButton>
        )
      }
      dataSource={faqList}
      renderItem={(item: IFaq) => <Item {...item} key={item.id} />}
    />
  );
};

export const getServerSideProps: GetServerSideProps = async context => {
  const { id } = context.params as any;

  const hotWords = await actionServer.getHotWord();
  const productList = await actionServer.getFaqCategory();

  let categoryId = null;
  if (id !== 'default') {
    categoryId = id;
  } else if (productList?.length > 0) {
    categoryId = productList[0].id;
  }
  const res = await actionServer.getFaqList(categoryId, 1, pageSize);
  const fallback = {
    categoryId,
    productList: productList ?? [],
    list: res?.records ?? [],
    total: res?.total || 0,
    current: 1,
    hotWords: hotWords ?? [],
  };

  return {
    props: {
      ...fallback,
    },
  };
};
